import { createSlice } from '@reduxjs/toolkit';

import { loadApplications } from './applications-middleware';
import { logout } from '../auth/auth-middleware';
import { Application } from 'api';

type ApplicationsState = {
    applications: Application[];
    error: string | null;
    loading: 'idle' | 'pending';
};

const initialState: ApplicationsState = {
    applications: [],
    error: null,
    loading: 'idle',
};

export const applicationsSlice = createSlice({
    name: 'app/applications',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(loadApplications.fulfilled, (state, action) => {
                state.applications = action.payload.data;
                state.error = null;
                state.loading = 'idle';
            })
            .addCase(loadApplications.pending, (state) => {
                state.loading = 'pending';
                state.error = null;
            })
            .addCase(loadApplications.rejected, (state, action) => {
                state.error = action.payload as string;
                state.loading = 'idle';
            })
            .addCase(logout.fulfilled, (state) => {
                state.applications = [];
            });
    },
});

export default applicationsSlice.reducer;
